import { rest } from 'msw';

import { FONT_BRIGHTNESS } from '@hivebrite/design-system/Theme';

import { FONT_FILE_MIME_TYPES } from 'hb-react/backoffice/apps/Branding/constants/fontFileMimeTypes';

export const networkId = 42;

export const theming = {
  fo: {
    fo_background_color: 'rgba(190, 17, 17, 1)',
    fo_background_gradient: {
      angle: 40,
      color1: '#B711DB',
      color1Percentage: 34,
      color2: '#A01647',
      color2Percentage: 78,
      inlineCSS: 'linear-gradient(40deg, #B711DB 34%, #A01647 78%)',
      type: 'linear',
    },
    fo_background_type: 'SOLID',
    fo_button_border_radius: 10,
    fo_frame_background_color: 'rgba(200, 234, 106, 1)',
    fo_frame_border_radius: 10,
    fo_frame_drop_shadow: 'rgba(223, 255, 248, 0.2)',
    fo_frame_font_brightness: FONT_BRIGHTNESS.LIGHT,
    fo_filters_color: 'rgba(14, 234, 106, 1)',
    fo_focus_color: 'rgba(224, 14, 37, 1)',
    fo_group_menu_background_color: 'rgb(255, 255, 255)',
    fo_group_menu_font_brightness: FONT_BRIGHTNESS.DARK,
    fo_header_scrolled_background_color: 'rgba(167, 24, 255, 1)',
    fo_header_scrolled_color: 'rgba(210, 213, 253, 1)',
    fo_header_separator_display: false,
    fo_header_static_background_color: 'rgba(255, 255, 255, 1)',
    fo_header_static_color: 'rgba(255, 255, 255, 1)',
    fo_links_color: 'rgba(234, 14, 63, 1)',
    fo_main_navigation_change_on_scroll: true,
    fo_menu_scrolled_background_color: 'rgb(255, 255, 255)',
    fo_menu_scrolled_font_brightness: FONT_BRIGHTNESS.DARK,
    fo_menu_static_background_color: 'rgba(167, 24, 255, 1)',
    fo_menu_static_font_brightness: FONT_BRIGHTNESS.DARK,
    fo_outboxed_font_brightness: FONT_BRIGHTNESS.LIGHT,
    fo_outline_navigation_scrolled_color: 'rgba(165, 0, 250, 1)',
    fo_outline_navigation_static_color: 'rgba(165, 0, 250, 1)',
    fo_page_header_background_color: 'rgb(255, 255, 255)',
    fo_page_header_font_brightness: FONT_BRIGHTNESS.DARK,
    fo_primary_color: 'rgba(243, 13, 56, 1)',
    fo_inputs_font_brightness: FONT_BRIGHTNESS.LIGHT,
    fo_inputs_background_color: 'rgba(22, 13, 56, 1)',
    fo_inputs_outline_color: 'rgb(22, 240, 56)',
    fo_secondary_button_background_color: 'rgba(100, 13, 56, 1)',
    fo_secondary_button_font_brightness: FONT_BRIGHTNESS.LIGHT,
    fo_secondary_navigation_background_color: 'rgb(255, 255, 255)',
    fo_secondary_navigation_font_brightness: FONT_BRIGHTNESS.DARK,
    fo_website_header_logo: 'https://www.hivebrite.com/logo.png',
  },
  po: {
    po_background_color: 'rgba(222, 223, 251, 1)',
    po_footer_background_color: '#323A45',
    po_footer_color: '#FAFAFA',
    po_header_mobile_background_color: 'rgba(83, 102, 131, 1)',
    po_header_social_icons_static_color: 'rgba(0, 251, 255, 1)',
    po_header_static_background_color: '#323A45',
    po_header_static_color: 'rgba(187, 211, 249, 1)',
    po_links_color: 'rgba(233, 16, 234, 1)',
    po_login_button_background_color: 'rgba(224, 118, 0, 1)',
    po_login_button_color: null,
    po_outline_navigation_static_color: '#FD4329',
    po_primary_color: 'rgba(238, 16, 239, 1)',
    po_header_social_icons_are_displayed: true,
    po_header_is_sticky: true,
    po_header_menu_height: 65,
    po_website_header_logo: 'https://www.hivebrite.com/logo.png',
    po_website_footer_logo: 'https://www.hivebrite.com/logo.png',
  },
  global: {
    google_font_family: 'Montserrat',
    header_email: '#000',
    avatar: 'https://www.hivebrite.com/logo.png',
    favicon: 'https://www.hivebrite.com/logo.png',
    mobile_header_logo: 'https://www.hivebrite.com/logo.png',
    font_type: 'GOOGLE',
    custom_font_name: 'Helvetica',
    custom_font_weight_400: null,
    custom_font_weight_700: null,
    custom_font_weight_400_woff: null,
    custom_font_weight_400_ttf: null,
    custom_font_weight_700_woff: null,
    custom_font_weight_700_ttf: null,
  },
};

export const themingWithCustomFont = {
  ...theming,
  global: {
    ...theming.global,
    font_type: 'CUSTOM',
    custom_font_weight_400: {
      id: 1,
    },
    custom_font_weight_700: {
      id: 2,
    },
    custom_font_weight_400_woff: {
      default_url: 'https://network.hvbrt.com/storage/11/download',
      file_name: 'Dyname SSi - 400.woff',
      file_url: 'https://network.hvbrt.com/storage/11/download',
      id: 11,
      mime_type: FONT_FILE_MIME_TYPES.WOFF,
      name: 'Dyname SSi - 400.woff',
      size: 37408,
      virus_scan_status: 'not_scannable',
    },
    custom_font_weight_400_ttf: {
      default_url: 'https://network.hvbrt.com/storage/22/download',
      file_name: 'Dyname SSi - 400.ttf',
      file_url: 'https://network.hvbrt.com/storage/22/download',
      id: 22,
      mime_type: FONT_FILE_MIME_TYPES.TTF,
      name: 'Dyname SSi - 400.ttf',
      size: 47409,
      virus_scan_status: 'not_scannable',
    },
    custom_font_weight_700_woff: {
      default_url: 'https://network.hvbrt.com/storage/33/download',
      file_name: 'Dyname SSi - 700.woff',
      file_url: 'https://network.hvbrt.com/storage/33/download',
      id: 33,
      mime_type: FONT_FILE_MIME_TYPES.WOFF,
      name: 'Dyname SSi - 700.woff',
      size: 37408,
      virus_scan_status: 'not_scannable',
    },
    custom_font_weight_700_ttf: {
      default_url: 'https://network.hvbrt.com/storage/44/download',
      file_name: 'Dyname SSi - 700.ttf',
      file_url: 'https://network.hvbrt.com/storage/44/download',
      id: 44,
      mime_type: FONT_FILE_MIME_TYPES.TTF,
      name: 'Dyname SSi - 700.ttf',
      size: 47409,
      virus_scan_status: 'not_scannable',
    },
  },
};

export const getThemingWithAdvancedThemingHandler = () =>
  rest.get(
    Routes.backoffice_network_branding_index_path({ id: networkId }),
    (_, res, ctx) =>
      res(
        ctx.json({
          theming,
          advanced_theming_is_enabled: true,
          custom_font_is_enabled: false,
        }),
      ),
  );
export const getThemingWithoutAdvancedThemingHandler = () =>
  rest.get(
    Routes.backoffice_network_branding_index_path({ id: networkId }),
    (_, res, ctx) =>
      res(
        ctx.json({
          theming,
          advanced_theming_is_enabled: false,
          custom_font_is_enabled: false,
        }),
      ),
  );

export const getThemingWithCustomFontEnabledHandler = () =>
  rest.get(
    Routes.backoffice_network_branding_index_path({ id: networkId }),
    (_, res, ctx) =>
      res(
        ctx.json({
          theming,
          advanced_theming_is_enabled: true,
          custom_font_is_enabled: true,
        }),
      ),
  );

export const getThemingWithCustomFontHandler = () =>
  rest.get(
    Routes.backoffice_network_branding_index_path({ id: networkId }),
    (_, res, ctx) =>
      res(
        ctx.json({
          theming: themingWithCustomFont,
          advanced_theming_is_enabled: true,
          custom_font_is_enabled: true,
        }),
      ),
  );

export const getFonts = () =>
  rest.get(
    Routes.fonts_backoffice_network_branding_index_path({
      network_id: networkId,
    }),
    (_, res, ctx) =>
      res(
        ctx.json({
          all_google_fonts: [],
          default_fonts: [],
          verified_google_fonts: [],
        }),
      ),
  );

export const getFeatureFlags = () =>
  rest.get(Routes.feature_flag_settings_path(), (_, res, ctx) =>
    res(ctx.status(200)),
  );
